import { render, staticRenderFns } from "./NotClothes.vue?vue&type=template&id=13973f05&scoped=true"
import script from "./NotClothes.vue?vue&type=script&lang=js"
export * from "./NotClothes.vue?vue&type=script&lang=js"
import style0 from "./NotClothes.vue?vue&type=style&index=0&id=13973f05&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13973f05",
  null
  
)

export default component.exports